<footer>
  <div>
    <a href="https://liste-envies.desaintsteban.fr">liste d'envies</a>
    <a href="https://github.com/patou/liste-envies">github</a>
  </div>
  <div>made with love by Patrice et Emmanuel DE SAINT STEBAN</div>
</footer>
